export class clientTemplate {
  view = false;
  edit: boolean = false;
  onboardingId: string;
  datalist: any
  add: boolean = false;
  statusinfo: string;
  onboardingStatusLovCode: string
  templateToOnboard = false;
  templatelistLid: string;
  templatename: string;
}

export class employeeTemplate {
  view = false;
  edit: boolean = false;
  datalist: any
  add: boolean = false;
  statusinfo: string;
  templateToOnboard = false;
  documentid: string
  templateName: string;
}

export class onBoardingtemplateBO {
  agencyId: string | null = "00000000-0000-0000-0000-000000000000";
  agencyName: string | null;
  documentType: string;
  searchColumn: string;
  searchText: string;
  orderColumn: string = 'agencyName';
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  field: string = 'agencyName';
  value: string = '';
  matchCase: boolean = false;
  operator: string = "startswith";
  type: string = "";
  message: string;
  userId: string | null = "00000000-0000-0000-0000-000000000000";
  statusLid: string = "00000000-0000-0000-0000-000000000000";
}

export class functionpermission {
  clienttemplatecreate: boolean = true
  clienttemplateupdate: boolean = true
  employeetemplatecreate: boolean = true
  employeetemplateupdate: boolean = true
}
